import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import {
  loadFilterTemplateByIdFailed,
  loadFilterTemplateByIdSuccessful,
} from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* loadFilterTemplateById(action) {
  try {
    const url = `${BACKEND_URL}/filter-templates/${action.payload}`;
    const response = yield makeRequest(url, {}, action, 'GET', true);
    if (response.status === OK) {
      const data = yield response.json();
      yield put(loadFilterTemplateByIdSuccessful(data.data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadFilterTemplateByIdFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(loadFilterTemplateByIdFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
